import TinyMCEField from './TinyMCEField';

export default TinyMCEField;
